/** Formatting for things a reviewer reads off the screen. */

/**
 * Epoch seconds as a date and time.
 *
 * The API sends epoch seconds rather than a formatted string, so this renders
 * in the reader's own timezone. That matters more than it looks: a workpaper
 * generated at 9am in Sydney is the previous day in UTC, and a BAS period is
 * bounded by dates. Showing a date that disagrees with the one on the
 * workpaper would be a recurring "which one is right?" question.
 */
export function formatWhen(epochSeconds: number): string {
  if (!epochSeconds) return "";
  return new Date(epochSeconds * 1000).toLocaleString("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

/** The same instant, spelled out in full, for a tooltip. */
export function formatWhenLong(epochSeconds: number): string {
  if (!epochSeconds) return "";
  return new Date(epochSeconds * 1000).toLocaleString("en-AU", {
    dateStyle: "full",
    timeStyle: "long",
  });
}
